import React from "react";
import colors from "@streeteasy/design-system/deprecated/colors";
import { oneOf, string } from "prop-types";

import iconClasses from "./iconClasses";
import Icon from "./styled";

const FontAwesomeIcon = ({
  className,
  color,
  desktopPadding,
  fontSize,
  iconClass,
  mobilePadding
}) => {
  const fontAwesomeClass =
    iconClass in iconClasses ? iconClasses[iconClass] : `fa-${iconClass}`; // used for backwards compatibility

  return (
    <Icon
      aria-hidden="true"
      className={`fa ${fontAwesomeClass}${className ? ` ${className}` : ""}`}
      color={color}
      desktopPadding={desktopPadding}
      fontSize={fontSize}
      mobilePadding={mobilePadding}
    />
  );
};

FontAwesomeIcon.propTypes = {
  /** An additional optional className to pass to the icon */
  className: string,
  /** Give the icon an initial color (must be a color from the SE color library or "inherit") */
  color: oneOf([...Object.keys(colors), "inherit"]),
  /** Expects a string with values for padding on laptop and desktops */
  desktopPadding: string,
  /** Give the icon size in px */
  fontSize: string,
  /** The name of an icon in the iconClasses file */
  iconClass: string.isRequired,
  /** A string with information about padding on mobile devices. Default is null */
  mobilePadding: string
};

FontAwesomeIcon.defaultProps = {
  className: "",
  color: "whaleGrey",
  desktopPadding: "0 6px 0 6px",
  fontSize: "14px",
  mobilePadding: null
};

export default FontAwesomeIcon;
